module.exports = __webpack_public_path__ + "static/media/Battery-50.44c60eeb.svg";